import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * Cross-link row for the Administration cluster. Each admin page renders this
 * so the identity (People/SSO/SCIM), data (Connectors) and governance
 * (Audit log/Settings) flows reference each other instead of being reachable
 * only via the sidebar.
 */
const ADMIN_PAGES: { key: string; labelKey: string; fallback: string }[] = [
  { key: 'people', labelKey: 'nav.people', fallback: 'People' },
  { key: 'connectors', labelKey: 'nav.connectors', fallback: 'Connectors' },
  { key: 'sso', labelKey: 'nav.sso', fallback: 'SSO' },
  { key: 'scim', labelKey: 'nav.scim', fallback: 'SCIM' },
  { key: 'audit-log', labelKey: 'nav.audit', fallback: 'Audit log' },
  { key: 'settings', labelKey: 'nav.settings', fallback: 'Settings' },
];

export function AdminSiblingNav({ wsId, current }: { wsId: string; current: string }) {
  const { t } = useTranslation();
  return (
    <nav className="mb-6 flex flex-wrap items-center gap-x-4 gap-y-1 border-b border-ink-100 pb-3 text-[12px]">
      <span className="text-[10px] uppercase tracking-[0.14em] text-ink-400 font-semibold mr-1">
        {t('nav.group.admin', { defaultValue: 'Administration' })}
      </span>
      {ADMIN_PAGES.map((a) => (
        <Link
          key={a.key}
          to={`/app/workspace/${wsId}/${a.key}`}
          aria-current={a.key === current ? 'page' : undefined}
          className={
            a.key === current
              ? 'font-semibold text-ink-900'
              : 'text-ink-500 hover:text-accent-600'
          }
        >
          {t(a.labelKey, { defaultValue: a.fallback }) as string}
        </Link>
      ))}
    </nav>
  );
}
